module.exports = __webpack_public_path__ + "static/media/iconCliente.c90f88e7.svg";